import React from 'react'

const ButtonPrimary= React.forwardRef((props, ref) =>{
    return (
        <button ref={ref} className={props.classValue} disabled={props.d} onClick={props.onClick} datapath={props.datapath} form={props.form} datatype={props.datatype} type={props.type} data-seasonid={props.seasonid}>
            <span datapath={props.datapath}>{props.textValue}</span>
        </button>
    )
}) 
export default ButtonPrimary